/**
 * Uses require() inside the function instead of import at the top of the file
 * to break the circular dependencies.
 *
 * With dynamic require(), the store is only loaded when getAuth() is called,
 * not during module initialization, preventing the error:
 * "Cannot access 'xxxApi' before initialization"
 */

import type { RootState } from '../../store/store';

export default function getAuth(): RootState['auth'] {
  const { store } = require('../../store/store');
  return (store.getState() as RootState).auth;
}
